import DashboardWrapper from "../component/DashboardWrapper"
import MedicationTimestampSelection from "../component/dashboard_medication/MedicationTimestampSelection"
import RequirePatientSelection from "../component/require/RequirePatientSelection"
import { useAppDispatch, useAppSelector } from "../redux/store/hooks"
import {
    selectDashboardSelectedPatient,
    selectDashboardSelectedValueType,
    selectMedicationRisks,
    selectMedicationTimestamp
} from "../redux/ProfessionalDashboard"
import notNull from "../util/notNull"
import MedicationQuestionnaireView from "../component/dashboard_medication/MedicationQuestionnaireView"
import MedicationCounterMeasureView from "../component/dashboard_medication/MedicationCounterMeasureView"
import MedicationRisksView from "../component/dashboard_medication/MedicationRisksView"
import Card from "../component/Card"
import SmallHeadingComponent from "../component/SmallHeadingComponent"
import Button from "../component/Button"
import mockPatient from "../onboarding/mock/mockPatient"
import {
    mockPatientUsed,
    selectOnboardingIsRunningState,
    selectOnboardingStep
} from "../redux/Onboarding"
import {
    GetPatientMedicationRisksSpecification,
    GetPatientsOfProfessionalResponsePayload,
    ResetMedicationIndicatorsSpecification,
    ValueType
} from "pokal_api"
import { dispatchThunk } from "../redux/thunk/thunkify"
import MedicationList from "../component/dashboard_medication/MedicationList"
import { useNavigate } from "react-router-dom"
import { NAVIGATION_VIEW, NavigationPaths } from "../navigation/NavigationController"
import { useEffect, useState } from "react"
import { ArrayElement } from "../types/ArrayElement"

function MedicationView() {
    const patient = useAppSelector(selectDashboardSelectedPatient)
    const timestamp = useAppSelector(selectMedicationTimestamp)
    const risks = useAppSelector(selectMedicationRisks)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    
    const running  = useAppSelector(selectOnboardingIsRunningState)
    const step     = useAppSelector(selectOnboardingStep)

    // ─── use mock patient while the onboarding is active ──────────────────────────────
    const selectedPatient = mockPatientUsed(running, step) ? mockPatient()[0] : patient

    function onReset() {
        const success = window.confirm(
            "ACHTUNG! Das Zurücksetzen des Erfassungszeitpunktes dient ausschließlich dem Ausbessern von bei der Eingabe erfolgten Fehlern.  Klicken Sie auf Zurücksetzen werden die alten Daten gelöscht und mit der neuen Eingabe überschrieben. Wenn Sie einen außerplanmäßigen Test durchführen wollen, wählen sie bitte Sonstiger Erfassungszeitpunkt aus. Diesen dürfen Sie jederzeit überschreiben."
        )
        if (success && notNull(selectedPatient)) {
            ResetMedicationIndicatorsSpecification.request({
                patient: selectedPatient.id,
                timestamp
            }).then(() => {
                dispatchThunk(
                    dispatch,
                    GetPatientMedicationRisksSpecification,
                    {
                        patient: selectedPatient.id,
                    }
                )
            })
        }
    }

    return (
        <RequirePatientSelection>
            {notNull(selectedPatient) && (
                <DashboardWrapper
                    onClick={() => {
                        navigate(NavigationPaths[NAVIGATION_VIEW.PATIENT_OVERVIEW].path)
                    }}
                    title={`${selectedPatient.firstName} ${selectedPatient.lastName}`}
                    maxWidth={1000}>
                    <MedicationList />
                    <MedicationTimestampSelection />
                    {notNull(risks) && (
                        <>
                            {risks[timestamp].indicators.length === 0 ? (
                                <MedicationQuestionnaireView />
                            ) : (
                                <>
                                    <MedicationRisksView />
                                    <MedicationCounterMeasureView />
                                    <Card>
                                        <div className={"flex space-y-4 flex-col"}>
                                            <SmallHeadingComponent>
                                                Erfassungszeitpunkt zurücksetzen
                                            </SmallHeadingComponent>
                                            <div>
                                                Wenn sie die Daten für diesen
                                                Erfassungszeitpunkt zurücksetzen
                                                möchten um den Fragebogen erneut
                                                ausfüllen zu können bestätigen Sie
                                                hier.
                                            </div>
                                            <Button
                                                onClick={onReset}
                                                tint={"bg-rose-600"}>
                                                Zurücksetzen
                                            </Button>
                                        </div>
                                    </Card>
                                </>
                            )}
                        </>
                    )}
                </DashboardWrapper>
            )}
        </RequirePatientSelection>
    )
}

export default MedicationView
